import { CLASS_VISIBLE } from '../tools/constants/classes';

const SELECTOR_STICKY_ATC = '[data-sticky-add-to-cart]';
const SELECTOR_STICKY_ATC_BUTTON = '[data-sticky-add-to-cart-button]';
const SELECTOR_PRODUCT_FORM_ADD = '[data-product-form-add]';
const SELECTOR_MOBILE_ATC = '[data-mobile-sticky-atc]';
const SELECTOR_SWATCH_PROMPT = '[data-swatch-prompt]';
const SELECTOR_SWATCH = '[data-swatch-object]';

const onScroll = () => {
  // Capture the first (main) product form button
  const productDetails = document.querySelector<HTMLElement>(
    SELECTOR_PRODUCT_FORM_ADD
  );
  const stickyATC = document.querySelector<HTMLElement>(SELECTOR_STICKY_ATC);

  if (!productDetails || !stickyATC) return;

  const productMainBottom = productDetails.getBoundingClientRect().bottom;

  // If scrolling past product info, show sticky ATC
  if (productMainBottom < 0) {
    stickyATC.classList.add(CLASS_VISIBLE);
  } else {
    stickyATC.classList.remove(CLASS_VISIBLE);
  }
};

document
  .querySelectorAll<HTMLElement>(SELECTOR_STICKY_ATC)
  .forEach((container) => {
    const mobileATC = container.querySelector<HTMLElement>(SELECTOR_MOBILE_ATC);
    const prompt = document.querySelector<HTMLElement>(SELECTOR_SWATCH_PROMPT);
    const swatches = document.querySelectorAll<HTMLElement>(SELECTOR_SWATCH);

    if (!mobileATC) return;

    // The mobileATC button is a shim. Delegate form submission to the true
    // submit button.
    mobileATC.addEventListener('click', function (evt) {
      evt.preventDefault();
      const atcSubmitButton = container.querySelector<HTMLElement>(
        SELECTOR_STICKY_ATC_BUTTON
      );
      if (!atcSubmitButton) return;
      atcSubmitButton.click();

      // if (prompt) {
      //   prompt.classList.add(CLASS_VISIBLE);
      //   swatches.forEach((swatch) => {
      //     swatch.addEventListener('click', () => {
      //       prompt.classList.remove(CLASS_VISIBLE);
      //     });
      //   });
      // }
    });

    function handleClick(event) {
      const clickedSwatchValue = event.target.getAttribute('data-value') || event.target.closest('[data-value]').getAttribute('data-value');
      let twinSwatches = document.querySelectorAll<HTMLElement>(`[data-value=${clickedSwatchValue}]`);

      twinSwatches.forEach(swatch => {
        if (!swatch.classList.contains('is-selected')) {
          swatch.click();
        }
      });
    }

    swatches.forEach(swatch => {
      swatch.addEventListener('click', handleClick);
    });
  });

window.addEventListener('scroll', onScroll);
